import React, { memo } from 'react';
import BlockMarkdown from './BlockMarkdown';
import { extractBlockItems } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function ComparisonTableBlock({ block, renderContext }) {
    const columns = Array.isArray(block.columns) ? block.columns.filter(Boolean) : [];
    const rows = extractBlockItems(block);
    if (!columns.length && !rows.length) return null;

    const resolvedColumns =
        columns.length > 0
            ? columns.map(col => (typeof col === 'string' ? { key: col, label: col } : col))
            : Object.keys(rows[0] || {})
                  .filter(key => key !== 'id')
                  .map(key => ({ key, label: key }));

    return (
        <section className={styles.comparisonBlock} aria-label={block.title || 'Comparison table'}>
            {block.title ? <h3 className={styles.blockTitle}>{block.title}</h3> : null}
            <div className={styles.tableWrap}>
                <table className={styles.comparisonTable}>
                    <thead>
                        <tr>
                            {resolvedColumns.map(col => (
                                <th key={col.key || col.label} scope="col">
                                    {col.label || col.key}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={row.id || `row-${rowIndex}`}>
                                {resolvedColumns.map(col => {
                                    const key = col.key || col.label;
                                    const value = row[key];
                                    return (
                                        <td key={`${row.id || rowIndex}-${key}`}>
                                            {typeof value === 'string' && value.includes('\n') ? (
                                                <BlockMarkdown content={value} {...renderContext} />
                                            ) : (
                                                value ?? '—'
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
}

export default memo(ComparisonTableBlock);
